import type { BadgeVariant } from '../../components/ui/badge';
import type { CampaignStatus } from '../../types/campaign';

/**
 * Map a Campaign status to a Design System status-badge variant (§8.3).
 * Shared by CampaignDetail + CampaignList so the pill reads identically.
 */
export function campaignStatusVariant(status: CampaignStatus): BadgeVariant {
  switch (status) {
    case 'active':
      return 'success';
    case 'draft':
      return 'info';
    case 'inactive':
      return 'warning';
    default:
      return 'neutral'; // archived
  }
}
